<template>
    <div class="app-container py-4">
        <div
                v-if="isUserLoggedIn"
                class="profile-personal profile-inner-page px-0 px-sm-4"
        >
            <v-row class="mx-0">
                <v-col cols="12" md="4" class="hidden-sm-and-down pr-4">
                    <profile-menu @logout="logout" :active-link="0"></profile-menu>
                </v-col>
                <v-col cols="12" md="8">
                    <personal-card-skeleton v-if="loading"></personal-card-skeleton>
                    <v-card outlined class="profile-card border-transparent" v-if="!loading">
                        <v-card-title class="text-uppercase justify-center">{{ $t('personalInfo') }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-title class="text-uppercase justify-center">{{ userName }}</v-card-title>
                        <v-card-text class="text-center">{{ tradeStatus }}</v-card-text>
                        <v-row class="mx-0">
                            <v-col cols="12" xs="12" sm="4" >
                                <div class="title pa-4">{{ $t('myInfo') }}</div>
                                <v-list dense>
                                    <v-list-item v-for="field in fields.myInfo" :key="field.name">
                                        <v-list-item-icon>
                                            <v-icon class="text--main-yellow">{{ field.icon }}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <div>
                                                <span v-if="field.prepend">{{ field.prepend }}</span>
                                                <span v-if="field.name !== 'company'" >{{ field.content }}</span>
                                                <router-link :to="companyLinkPrefix + companyId" v-if="field.name === 'company'">
                                                    <span class="text-underline-hover black--text">{{ field.content }}</span>
                                                </router-link>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                            <v-col cols="12" xs="12" sm="4" >
                                <div class="title pa-4">{{ $t('contacts') }}</div>
                                <v-list dense>
                                    <v-list dense>
                                        <v-list-item v-for="field in fields.contacts" :key="field.name">
                                            <v-list-item-icon>
                                                <v-icon class="text--main-yellow">{{ field.icon }}</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <span class="d-flex" v-if="field.prepend">{{ field.prepend }}</span>
                                                <span class="d-flex">{{ field.content }}</span>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-list>
                            </v-col>
                            <v-col cols="12" xs="12" sm="4" >
                                <div class="title pa-4 text-center text-sm-left">{{ $t('profileSettings') }}</div>
                                <v-list dense>
                                    <v-list dense>
                                        <v-list-item class="justify-center justify-sm-start">
                                            <edit-dialog></edit-dialog>
                                        </v-list-item>
                                    </v-list>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import EditDialog from '../../../app-front/components/dialogs/PersonalEdit';
    import PersonalCardSkeleton from '../../../app-front/components/skeletons/PersonalInfoSkeleton';
    import ProfileDataProvider from '../../../app-front/mixins/ProfileDataProvider';
    import ProfileMenu from '../../../app-front/components/profile/menu';
    import ProfileService from '../../../app-front/services/api/ProfileService';
    import RouteAccess from '../../../app-front/mixins/RouteAccess';
    import WatchLogoutRedirect from '../../../app-front/mixins/WatchLogoutRedirect';

    import '../../../../sass/app-front/profile.scss';

    export default {
        name: "ProfilePersonal",
        components:{
            ProfileMenu,
            EditDialog,
            PersonalCardSkeleton
        },
        mixins:[
            ProfileDataProvider,
            RouteAccess,
            WatchLogoutRedirect
        ],
        data(){
            return {
                fields:{
                    myInfo:[],
                    contacts:[],
                },
                isDataReceived: true,
                loading: true,
                metaUrl: '/profile/personal-info',
                companyInfo: null,
                companyLinkPrefix: '/companies/',
            }
        },
        computed: {
            companyId() {
                return this.companyInfo ? this.companyInfo.company.id : null;
            },
            userName(){
                if(this.profileData.firstName || this.profileData.lastName) {
                    const data = [];

                    if (this.profileData.firstName) data.push(this.profileData.firstName);
                    if (this.profileData.lastName) data.push(this.profileData.lastName);

                    return data.join(' ');

                } else {
                    return '';
                }
            },
            tradeStatus() {
                const statuses = [];

                if(this.profileData.isBuyer) {
                    statuses.push(this.$t('buyer'))
                }

                if(this.profileData.isSeller) {
                    statuses.push(this.$t('seller'))
                }

                return statuses.join(' / ');
            }
        },
        methods: {
            authFailRouteHandle() {
                console.log('fail...');
            },
            authSuccessRouteHandle() {
                this.profileData = this.storeProfileData;
                this.setFields();
            },
            getCompany() {
                ProfileService.getGeneralData()
                    .then(res => {
                        this.companyInfo = res.data.profileData;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            logout() {
                this.initLogout();
            },
            setFields(){
                if(!Object.keys(this.storeProfileData)) {
                    return false;
                }

                const myInfo = [
                    {
                        icon: 'person_outline',
                        name: 'role',
                        content: this.tradeStatus,
                    },
                    {
                        icon: 'account_balance',
                        name: 'company',
                        content: this.profileData.company ? this.profileData.company.name : '',
                    },
                    {
                        icon: 'schedule',
                        name: 'date',
                        content: this.profileData.date || '',
                        prepend: 'На ' + this.$store.state.app.name + ' с '
                    },
                ];

                const contacts = [
                    {
                        icon: 'place',
                        name: 'city',
                        content: this.profileData.geo ? this.profileData.geo.name : '',
                    },
                    {
                        icon: 'mail',
                        name: 'email',
                        content: this.profileData.email || '',
                    },
                    {
                        icon: 'settings_phone',
                        name: 'phone',
                        content: this.profileData.phone ? this.profileData.phone.formatted : ''
                    },
                ];

                this.fields = {
                    myInfo: myInfo,
                    contacts: contacts
                };

                this.loading = false;
            }
        },
        created() {
            this.getCompany();
        },
        watch: {
            storeProfileData(){
                this.authSuccessRouteHandle();
            }
        }
    }
</script>

<style scoped>

</style>
